import React, { useEffect, useRef } from "react";

/** Подписи аналитик без стороны; ключ в данных — field + Dt / Kt */
export const ANALYTIC_FIELD_LABELS = {
  account: "Счет",
  articleOpiu: "Статья ОПИУ",
  cfoOpiu: "ЦФО ОПИУ",
  articleDds: "Статья ДДС",
  cfoDds: "ЦФО ДДС",
  project: "Проект",
  department: "Отделение",
  counterparty: "Контрагент",
  employee: "Сотрудник",
  contract: "Договор",
  nomenclature: "Номенклатура",
  fixedAsset: "Основное средство",
  intangibleAsset: "Нематериальный актив",
  cashAccount: "Денежный счёт",
  workType: "Вид работ",
};

/** Заполненные аналитики одной стороны в формате [{ label, value }] */
export const getSideAnalytics = (fields, suffix) =>
  Object.keys(ANALYTIC_FIELD_LABELS)
    .filter((field) => fields?.[`${field}${suffix}`] != null)
    .map((field) => ({
      label: ANALYTIC_FIELD_LABELS[field],
      value: fields[`${field}${suffix}`],
    }));

export const AnalyticsCell = ({ items, maxVisible = 2 }) => {
  if (!items?.length) return <span className="oj-empty">—</span>;
  const visible = items.slice(0, maxVisible);
  const rest = items.length - maxVisible;

  return (
    <div className="oj-analytics">
      {visible.map((item) => (
        <div key={`${item.label}-${item.value}`} className="oj-analytics__row">
          <span className="oj-analytics__label">{item.label}:</span>{" "}
          <span className="oj-analytics__value">{item.value}</span>
        </div>
      ))}
      {rest > 0 && <span className="oj-analytics__more">+{rest}</span>}
    </div>
  );
};

/** Чекбокс строки таблицы; клик не всплывает до обработчика строки */
export const Checkbox = ({
  checked,
  indeterminate = false,
  disabled = false,
  label,
  onChange,
}) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) ref.current.indeterminate = indeterminate;
  }, [indeterminate]);

  return (
    <input
      ref={ref}
      type="checkbox"
      className="oj-check"
      checked={checked}
      disabled={disabled}
      aria-label={label}
      onClick={(event) => event.stopPropagation()}
      onChange={onChange}
    />
  );
};

export const SortIcon = () => (
  <svg
    className="oj-sort-icon"
    width="10"
    height="14"
    viewBox="0 0 10 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M5 1L8.5 5H1.5L5 1Z" fill="#9AA4B2" />
    <path d="M5 13L1.5 9H8.5L5 13Z" fill="#9AA4B2" />
  </svg>
);
